import { LineBreak } from '@/components/LineBreak';
import { LabradorComponent } from '@/types/component';

export const LabradorLineBreak: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <LineBreak {...props} />;
};
